import AwsConfig_IN_STAG from '../Config/AwsConfig_IN_STAG.json'
import AwsConfig_IN_PROD from '../Config/AwsConfig_IN_PROD.json'
const Config = require('./Config.json')

let AwsConfig
switch (Config.Environment) {
  case 'Development':
    AwsConfig = AwsConfig_IN_STAG
    break
  case 'Production':
    AwsConfig = AwsConfig_IN_PROD
    break
  default:
    AwsConfig = AwsConfig_IN_STAG
    break
}
export default AwsConfig
